import { render, staticRenderFns } from "./retourGame.vue?vue&type=template&id=70993af4&scoped=true"
import script from "./retourGame.vue?vue&type=script&lang=js"
export * from "./retourGame.vue?vue&type=script&lang=js"
import style0 from "./retourGame.vue?vue&type=style&index=0&id=70993af4&prod&lang=css"
import style1 from "./retourGame.vue?vue&type=style&index=1&id=70993af4&prod&lang=scss&scoped=true"
import style2 from "./retourGame.vue?vue&type=style&index=2&id=70993af4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "70993af4",
  null
  
)

export default component.exports